import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GcListComponent,
  GcListItemComponent,
  GcTextComponent,
  IpoClickOutsideDirective,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-options-popup',
  imports: [
    IpoClickOutsideDirective,
    IpoTranslatePipe,
    GcListComponent,
    GcListItemComponent,
    GcTextComponent,
  ],
  templateUrl: './options-popup.component.html',
  styleUrl: './options-popup.component.scss',
})
export class OptionsPopupComponent {
  @Input() fileName: string;
  @Output() closePopup = new EventEmitter();
  @Output() download = new EventEmitter();
  @Output() delete = new EventEmitter();

  //This counter is needed becuase the click that opens the component will trigger the click outside directive.
  //That causes the compoennt to close emidietly as it opens
  //The counter prevents that from happening
  firstClick = true;

  handleClosePopup() {
    if (!this.firstClick) {
      this.closePopup.emit();
    } else {
      this.firstClick = false;
    }
  }
}
